import { cn } from "@/lib/utils";
import { Skeleton } from "@/components/ui/skeleton";

interface ProductCardSkeletonProps {
    className?: string;
}

export const ProductCardSkeleton = ({ className }: ProductCardSkeletonProps) => {
    return (
        <div
            className={cn(
                "group relative flex flex-col h-full",
                "rounded-[2.5rem] border border-primary-50 bg-white",
                "p-3 sm:p-5",
                className
            )}
        >
            {/* Image Skeleton */}
            <div className="relative aspect-square rounded-[2rem] overflow-hidden mb-4 bg-primary-50/30">
                <Skeleton className="h-full w-full" />
            </div>

            {/* Title Skeleton */}
            <div className="flex flex-col gap-2 mt-2 text-center">
                <Skeleton className="h-5 w-3/4 mx-auto rounded-full" />
                <Skeleton className="h-4 w-1/2 mx-auto rounded-full" />
            </div>

            {/* Detail Section Skeleton (Weight + Price) */}
            <div className="mt-6 mb-6 flex items-center justify-between gap-3 px-1">
                <Skeleton className="h-8 w-20 rounded-xl" />
                <Skeleton className="h-10 w-24 rounded-lg" />
            </div>

            {/* CTA Actions Skeleton */}
            <div className="flex items-center gap-3 mt-auto">
                <Skeleton className="h-11 flex-1 rounded-xl" />
                <Skeleton className="h-11 w-11 shrink-0 rounded-xl" />
            </div>
        </div>
    );
};
